import "./Ops.css";
import DataTable from "../../../Components/DataTable/DataTable";
import PageHead from "../../../Components/PageHead/PageHead";
import AddOpModel from "../../../Modals/AddOpModal/AddOpModel";

import { useEffect, useState, useRef } from "react";
import { Get } from "../../../Services/Server";
import Url from "../../../Services/Url";
import { UserRecOp } from "../../../Data/UserRec";
import Role from "../../../Data/Role";
import { useNavigate } from "react-router-dom";
import TaskTooltip from "../../../Components/TaskToolTip/TaskToolTip";
import { Eye } from "lucide-react";

const OpsList = ({ navoption, ModalAction, data }) => {
	const navigate = useNavigate();
	const tooltipRef = useRef(null);
	const [tooltip, setTooltip] = useState({
		visible: false,
		position: { x: 0, y: 0 },
		userId: null,
	});

	const handleAddOp = () => {
		const Options = {
			title: "Add Operation",
			element: AddOpModel,
			closeModal: handleCloseModal,
		};
		ModalAction.openModal(Options);
	};

	const handleCloseModal = () => {
		load();
		ModalAction.closeModal();
	};

	const handleChatClick = (userData, position) => {
		setTooltip({
			visible: true,
			position: position,
			userId: userData.id || userData.userId || userData,
		});
	};

	const closeTooltip = () => {
		setTooltip({
			visible: false,
			position: { x: 0, y: 0 },
			userId: null,
		});
	};

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				tooltip.visible &&
				tooltipRef.current &&
				!tooltipRef.current.contains(event.target)
			) {
				closeTooltip();
			}
		};

		if (tooltip.visible) {
			document.addEventListener("mousedown", handleClickOutside);
		}

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [tooltip.visible]);

	const [currentTasks, setCurrentTasks] = useState({
		data: [],
	});

	const load = () => {
		Get(Url.staffByrole(Role.operation))
			.then((resp) => {
				setCurrentTasks({ data: resp });
			})
			.catch((error) => {
				console.error("Error loading operations staff:", error);
				setCurrentTasks({ data: [] });
			});
	};

	useEffect(() => {
		load();
	}, []);

	const flex = [35, 35,25, 5];

	const handleClick = (e) => {
		navigate("Details", { state: e });
	};

	const UserRecOpWithTooltip = (data, index) => {
		const baseData = UserRecOp(data, index);

		if (baseData && baseData.length >= 3) {
			baseData.push(
				<div
					key={`tooltip-${index}`}
					className="chat-icon-cell"
					onClick={(e) => {
						e.stopPropagation();
						const rect = e.currentTarget.getBoundingClientRect();
						handleChatClick(data, {
							x: rect.left + rect.width / 2,
							y: rect.bottom + 10,
						});
					}}
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						cursor: "pointer",
						padding: "8px",
						borderRadius: "50%",
						width: "32px",
						height: "32px",
						margin: "0 auto",
						backgroundColor: "#f0f0f0",
						transition: "all 0.2s ease",
						border: "2px solid #14b8ff",
					}}
					onMouseEnter={(e) => {
						e.currentTarget.style.backgroundColor = "#14b8ff";
						e.currentTarget.style.transform = "scale(1.1)";
					}}
					onMouseLeave={(e) => {
						e.currentTarget.style.backgroundColor = "#f0f0f0";
						e.currentTarget.style.transform = "scale(1)";
					}}
					title="View tasks"
				>
					<Eye size={16} />
				</div>
			);
		}

		return baseData;
	};

	const heading = ["Op's Name", "Email", "Phone", "Tasks"];

	return (
		<div className="Ops">
			<PageHead
				navoption={navoption}
				addBtn={{ text: "Operation", onClick: handleAddOp }}
				title="Ops"
			/>
			<div className="UserList">
				<DataTable
					onClick={handleClick}
					reader={UserRecOpWithTooltip}
					flex={flex}
				>
					{{ ...currentTasks, heading }}
				</DataTable>
			</div>

			{tooltip.visible && (
				<div ref={tooltipRef}>
					<TaskTooltip
						userId={tooltip.userId}
						isVisible={tooltip.visible}
						position={tooltip.position}
						Get={Get}
						Url={Url}
					/>
				</div>
			)}
		</div>
	);
};

export default OpsList;
